import Logo from "./Logo";
import { Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F172A] text-white/85"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 pt-10 md:pt-16 pb-6 md:pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12">
          <div className="md:col-span-5">
            <img
              src="/assets/vish-logo-footer.png"
              alt="Vish Capital"
              className="h-14 w-auto object-contain"
            />
            <p className="mt-4 md:mt-5 max-w-sm text-[13.5px] md:text-[14.5px] leading-[1.65] md:leading-[1.75] text-white/60">
              One Stop Financial Solutions — investments, insurance, loans and
              tax, handled by one trusted partner.
            </p>
            <div className="mt-5 md:mt-8 flex gap-3">
              {[Instagram].map((Icon, i) => (
                <a
                  key={i}
                  href="https://www.instagram.com/vish.capital"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`footer-social-${i}`}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/15 hover:border-[#C9A227] hover:text-[#C9A227] transition-colors"
                  aria-label="Instagram"
                >
                  <Icon size={16} strokeWidth={1.5} />
                </a>
              ))}
            </div>
          </div>

          <FooterCol
            title="Services"
            links={[
              ["Investments", "#services"],
              ["Insurance", "#services"],
              ["Loan Facilitation", "#services"],
              ["Income Tax", "#services"],
            ]}
          />
          <FooterCol
            title="Company"
            links={[
              ["About", "#about"],
              ["Why Vish Capital", "#why"],
              ["FAQ", "#faq"],
              ["Contact", "#contact"],
            ]}
          />
          <FooterCol
            title="Contact"
            links={[
              ["9345093450", "tel:+919345093450"],
              ["customercare@vishcapital.com", "mailto:customercare@vishcapital.com"],
              ["2nd floor, Tidel Neo, Thirumuruganpoondi, Tirupur - 641652", "#contact"],
            ]}
          />
        </div>

        <div className="mt-8 md:mt-16 pt-5 md:pt-8 border-t border-white/10 flex items-center justify-center">
          <p className="text-[12px] tracking-wide text-white/55 text-center">
            © 2026 Attendy Technologies. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div className="md:col-span-2">
      <div className="text-[10px] md:text-[11px] tracking-[0.18em] md:tracking-[0.22em] uppercase text-white/50">
        {title}
      </div>
      <ul className="mt-3 md:mt-5 space-y-2 md:space-y-3">
        {links.map(([label, href]) => (
          <li key={label}>
            <a
              href={href}
              className="text-[14px] text-white/80 hover:text-white transition-colors"
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}